import { Component, OnInit, ChangeDetectorRef, NgZone, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  HttpClient,
  HttpParams,
  HttpRequest,
  HttpHeaders,
} from "@angular/common/http";
import { DatePipe } from "@angular/common";
import { ApiHelper } from "../../_helpers/api.helper";
import { CommonHelper } from "../../_helpers/common.helper";
import { ConstantHelper } from "../../_helpers/constant.helper";
import { AppConfig } from "../../app.config";
import { SweetAlertHelper } from "src/app/_helpers/sweet.alert.helper";
import { Message } from "src/app/_locale/message";
import { UserService } from "../../_services/user.service";
import { TextService } from "../admin-practice-dictation/textService";
import axios from "axios";
import { Injectable } from "@angular/core";
import { format } from "date-fns";
import Swal from "sweetalert2";
import { environment } from "src/environments/environment";
import { Location } from '@angular/common';

import { EMPTY, interval, Subscription } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AiSummaryCommonHelper } from 'src/app/_helpers/aiSummary.common.helper';

@Component({
  selector: "app-admin-radiology",
  templateUrl: "./admin-radiology.component.html",
  styleUrls: ["./admin-radiology.component.scss"],
})
@Injectable({
  providedIn: "root",
})
export class AdminRadiologyComponent implements OnInit, OnDestroy {
  resultJsonObj: any = {};

  loggedInUserId: string;
  loggedInUserRoleId: any;
  demographyUserId: string;
  comapnyName: string = ConstantHelper.COMPANY_NAME;
  childRoute: string;
  documentsList: any;
  patientName: any;
  showActionCommentModal = false;
  httpHeaders = new HttpHeaders({ "Content-Type": "application/json" });
  httpOptions = { headers: this.httpHeaders };
  showLoader = false;
  message = Message;
  initiatedBy: any;
  admins: any = [];
  userRoleVal: any = 0;
  selectedAdminForComment: any;
  selectedPhysicianForComment: any;
  showAllData = 1;

  dictationList: any = [];
  sharedDictationList: any = [];
  selectedComment: any = {};
  dtOptions: DataTables.Settings = {};
  patientTranscribeListFlag: boolean = false;
  fetchedText: any = "";
  showEditsummaryModal: boolean = false;
  editSummaryFlag: boolean = false;
  commentId: any;
  showAiSummaryModal: boolean = false;
  showShareSummaryModal: boolean = false;
  isSummarySigned: any = 0;
  isSummaryEdited: any = 0;
  showSignedAiSummaryModal: boolean = false;

  practices: any;
  physicians1: any;
  tempPhysician01: any = [];
  physicianInfo1: any = "";
  tempPractice01: any = [];
  practiceInfo1: any = "";
  finalPhysician01: any = [];
  selectedPhysiciansIdList: any = [];
  shareVisitSummariesFlag: boolean = false;
  isDelegating: any = 0;
  delegateId: any = 0;
  physicianName: any;
  showAiDictationModalPopup: boolean = false;
  chatBotVisible: boolean = false;
  patientId: string = ""; // Assuming this is where you store the patientId  
  responseStatus: string | null = null;  
  commentStatus: any | null = null;
  transStatus: string | null = null ;
  responseMessage: any;
  private isDestroyed = false;
  
  isDictationUploaded = false;
  isDictationStarted: boolean;
  documentsLength: any;
  profileObj: any;
  selectedAiSummary: any = {};
  summaryAnswer: string;
  summaryPopup : any = false;
  isSummaryAnswer: boolean = false;
  isAskSummaryAnswer: boolean = false;
  summaryAskAnswer: string;
  questionToSummary: string;
  confirmSummaryPopup: any = false;
  documentComment: string;
  saveSummaryBtn: boolean = false;
  facilityDetailsArray : any;
  openFacilityDetailsPopup : boolean = false;
  showDataVal: any;   
  isSummaryInputVisible: boolean;
  showModificationFields: boolean;
  addFileContent : any;
  addFileDescription: any;
  flag=0;
  isSatisfied: false;
  patientDetails : any = [];
  copyTooltip: string;
  copyText: string = "Copy";
  documentCommentDetails: any[] = [];
  documentCommentDetailsLength: boolean = false;
  loggedInUserName:any;
  
  // Speech recognition properties
  isRecordingDescription: boolean = false;
  isRecordingContent: boolean = false;
  isRecordingQuestion: boolean = false;
  recognition: any;
  isSpeechSupported: boolean = false;
  savedAskSummary: string;
  savedAskQuestion: string;
  lastAskedQuestion: string;
  constructor(
    public commonHelper: CommonHelper,
    private appConfig: AppConfig,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public sweetAlertHelper: SweetAlertHelper,
    private http: HttpClient,
    public userService: UserService,
    public datepipe: DatePipe,
    private textService: TextService,
    private cdr: ChangeDetectorRef,
    private zone: NgZone,
    private location: Location,
    private httpClient: HttpClient, 
    private aiSummaryCommonHelper: AiSummaryCommonHelper,   
  ) 
  {
    localStorage.setItem("childRoute", activatedRoute.snapshot.url[0].path);
    this.childRoute = activatedRoute.snapshot.url[0].path;
    this.loggedInUserId = this.activatedRoute.snapshot.paramMap.get('loggedInUserId');
    this.loggedInUserRoleId = localStorage.getItem('loggedInUserRoleId');
    this.demographyUserId = this.activatedRoute.snapshot.paramMap.get('demographyUserId');
    this.initiatedBy = localStorage.getItem('loggedInUserName');
    this.isDelegating = localStorage.getItem("isDelegating") ? localStorage.getItem("isDelegating") : 0;
    this.delegateId = localStorage.getItem("delegateId") ? localStorage.getItem("delegateId") : 0;
    this.physicianName = localStorage.getItem('loggedInUserName');
  } 
  
  ngOnInit() {
    this.fnFindAllDocuments('2');
    this.showDataVal = this.activatedRoute.snapshot.paramMap.get('showDataVal');
    // this.dtOptions = { order: []};    
    this.dtOptions = {
      order: [[5, 'desc']], // Set "Uploaded Date" (6th column, index 5) as default sorted in descending order
      columnDefs: [
        { orderable: false, targets: [6, 7, 8] }, // Disable sorting for "AI Summary", "Show Facility Details", and "Confirm/Comment" columns
      ]
    };
    this.showData(this.showDataVal)    
    this.commentStatus = sessionStorage.getItem("commentId");     
    this.findAdminList();
    this.findUserDetails(this.demographyUserId);    
    this.getUserPractices();    
    this.getPatientDetailsById()
    this.loggedInUserName = localStorage.getItem("loggedInUserName")
    
    // Initialize speech recognition
    this.initializeSpeechRecognition();
   }  

  // Initialize speech recognition
  initializeSpeechRecognition() {
    if ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window) {
      this.isSpeechSupported = true;
      const SpeechRecognition = (window as any)['SpeechRecognition'] || (window as any)['webkitSpeechRecognition'];
      this.recognition = new SpeechRecognition();
      this.recognition.continuous = false;
      this.recognition.interimResults = false;
      this.recognition.lang = 'en-US';
    } else {
      this.isSpeechSupported = false;
      console.warn('Speech recognition not supported in this browser');
    }
  }

  // Start recording for description field
  startRecordingDescription() {
    if (!this.isSpeechSupported) {
      this.sweetAlertHelper.alertPopUp('Speech recognition is not supported in your browser');
      return;
    }

    // If already recording, stop it
    if (this.isRecordingDescription) {
      this.stopRecording();
      return;
    }

    this.isRecordingDescription = true;
    this.recognition.continuous = true; // Enable continuous recording
    this.recognition.interimResults = true; // Enable interim results for better UX
    
    this.recognition.onstart = () => {
      console.log('Speech recognition started for description');
    };

    this.recognition.onresult = (event: any) => {
      // Get the final transcript from the last result
      const finalResult = event.results[event.results.length - 1];
      if (finalResult.isFinal) {
        const transcript = finalResult[0].transcript;
        // Append to existing text if there's already content, otherwise replace
        this.addFileDescription = this.addFileDescription ? this.addFileDescription + ' ' + transcript : transcript;
        if (!this.isDestroyed) {
          this.cdr.detectChanges();
        }
      }
    };

    this.recognition.onerror = (event: any) => {
      console.error('Speech recognition error:', event.error);
      this.isRecordingDescription = false;
      this.sweetAlertHelper.alertPopUp('Speech recognition error: ' + event.error);
      if (!this.isDestroyed) {
        this.cdr.detectChanges();
      }
    };

    this.recognition.onend = () => {
      // Only restart if user didn't manually stop it and there are no errors
      if (this.isRecordingDescription && this.recognition && !this.recognition.error) {
        // Add a small delay before restarting to avoid immediate restart loops
        setTimeout(() => {
          if (this.isRecordingDescription && this.recognition && !this.isDestroyed) {
            try {
              this.recognition.start();
            } catch (error) {
              this.isRecordingDescription = false;
            }
          }
        }, 100);
      }
      if (!this.isDestroyed) {
        this.cdr.detectChanges();
      }
    };

    this.recognition.start();
  }

  // Start recording for content field
  startRecordingContent() {
    if (!this.isSpeechSupported) {
      this.sweetAlertHelper.alertPopUp('Speech recognition is not supported in your browser');
      return;
    }

    // If already recording, stop it
    if (this.isRecordingContent) {
      this.stopRecording();
      return;
    }

    this.isRecordingContent = true;
    this.recognition.continuous = true; // Enable continuous recording
    this.recognition.interimResults = true; // Enable interim results for better UX
    
    this.recognition.onstart = () => {
      console.log('Speech recognition started for content');
    };

    this.recognition.onresult = (event: any) => {
      // Get the final transcript from the last result
      const finalResult = event.results[event.results.length - 1];
      if (finalResult.isFinal) {
        const transcript = finalResult[0].transcript;
        // Append to existing text if there's already content, otherwise replace
        this.addFileContent = this.addFileContent ? this.addFileContent + ' ' + transcript : transcript;
        if (!this.isDestroyed) {
          this.cdr.detectChanges();
        }
      }
    };

    this.recognition.onerror = (event: any) => {
      console.error('Speech recognition error:', event.error);
      this.isRecordingContent = false;
      this.sweetAlertHelper.alertPopUp('Speech recognition error: ' + event.error);
      if (!this.isDestroyed) {
        this.cdr.detectChanges();
      }
    };

    this.recognition.onend = () => {
      // Only restart if user didn't manually stop it and there are no errors
      if (this.isRecordingContent && this.recognition && !this.recognition.error) {
        // Add a small delay before restarting to avoid immediate restart loops
        setTimeout(() => {
          if (this.isRecordingContent && this.recognition && !this.isDestroyed) {
            try {
              this.recognition.start();
            } catch (error) {
              this.isRecordingContent = false;
            }
          }
        }, 100);
      }
      if (!this.isDestroyed) {
        this.cdr.detectChanges();
      }
    };

    this.recognition.start();
  }

  // Stop recording
  stopRecording() {
    if (this.recognition) {
      this.recognition.stop();
      this.isRecordingDescription = false;
      this.isRecordingContent = false;
      this.isRecordingQuestion = false;
      
      // Only call detectChanges if the component is not being destroyed
      if (!this.isDestroyed) {
        this.cdr.detectChanges();
      }
    }
  }

  // Start recording for question field
  startRecordingQuestion() {
    if (!this.isSpeechSupported) {
      this.sweetAlertHelper.alertPopUp('Speech recognition is not supported in your browser');
      return;
    }

    // If already recording, stop it
    if (this.isRecordingQuestion) {
      this.stopRecording();
      return;
    }

    this.isRecordingQuestion = true;
    this.recognition.continuous = true; // Enable continuous recording
    this.recognition.interimResults = true; // Enable interim results for better UX
    
    this.recognition.onstart = () => {
      console.log('Speech recognition started for question');
    };

    this.recognition.onresult = (event: any) => {
      // Get the final transcript from the last result
      const finalResult = event.results[event.results.length - 1];
      if (finalResult.isFinal) {
        const transcript = finalResult[0].transcript;
        // Set the question text
        this.questionToSummary = transcript;
        if (!this.isDestroyed) {
          this.cdr.detectChanges();
        }
      }
    };

    this.recognition.onerror = (event: any) => {
      console.error('Speech recognition error:', event.error);
      this.isRecordingQuestion = false;
      this.sweetAlertHelper.alertPopUp('Speech recognition error: ' + event.error);
      if (!this.isDestroyed) {
        this.cdr.detectChanges();
      }
    };

    this.recognition.onend = () => {
      // Only restart if user didn't manually stop it and there are no errors
      if (this.isRecordingQuestion && this.recognition && !this.recognition.error) {
        // Add a small delay before restarting to avoid immediate restart loops
        setTimeout(() => {
          if (this.isRecordingQuestion && this.recognition && !this.isDestroyed) {
            try {
              this.recognition.start();
            } catch (error) {
              this.isRecordingQuestion = false;
            }
          }
        }, 100);
      }
      if (!this.isDestroyed) {
        this.cdr.detectChanges();
      }
    };

    this.recognition.start();
  }
 


   async getPatientDetailsById() {
    this.patientDetails = [];
    const finalData = {
      patientId: this.patientId,
    };
    this.showLoader = true;

    this.http
      .post(this.appConfig.getLambdaUrl05() + ApiHelper.getPatientDetailsById, finalData, this.httpOptions)
      .subscribe(
        (res: any) => {
          if(res){
            this.patientDetails = res.commandResult.data.patientInfo;
            this.showLoader = false;
          }
        },
        (err) => {
          this.showLoader = false;
          console.error(err);
        }
      );
  }
 
  findUserDetails(demographicUserId) {
    const finalData = {
      id: demographicUserId,
    };
    this.showLoader = true;
    this.http
      .post(
        this.appConfig.getLambdaUrl05() + ApiHelper.name_findUserDetailsApi,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (apiResponse: any) => {
          this.patientName = this.userService.getUS_FromatName(
            apiResponse.commandResult.data.userInfo.FullName
          );
          this.showLoader = false;
        },
        (err) => {
          // console.error(err);
        }
      );
  }

  
  openReplyModal(commentId) {
    this.selectedComment = this.dictationList.find(
      (e) => e.CommentId == commentId
    );
  }

  openActionCommentModal() {
    this.showActionCommentModal = true;
  }

  closeActionCommentModal() {
    this.showActionCommentModal = false;
  }

  findAdminList() {
    this.admins = [];

    const finalData = {
      company_slug: ConstantHelper.COMPANY_SLUG,
      loggedInUserId: this.loggedInUserId,
      userRoleVal: 1,
    };
    this.http
      .post(
        // this.appConfig.getPhpUrl() + ApiHelper.php_getAdminUsersListApi,
        this.appConfig.getLambdaUrl06() + ApiHelper.getAdminUsersList,
        finalData,

        this.httpOptions
      )
      .subscribe(
        (apiResponse) => {
          this.resultJsonObj = apiResponse;
          this.admins = this.resultJsonObj.commandResult.data.adminUsers;
        },
        (err) => {}
      );
  }


  async goToDemographics() {
    // this.router.navigate([
    //   "/" + this.childRoute + "/demographics/" + this.loggedInUserId,
    // ]);
    // // }
    this.location.back();
  }

  openMp3FIle(recordingUrl: string): void {
    if (recordingUrl) {
      window.open(recordingUrl, "_blank");
    } else {
      console.error("Recording URL is not available.");
    }
  }

  openTranscript(TranscriptUrl: string): void {
    if (TranscriptUrl) {
      window.open(TranscriptUrl, "_blank");
    } else {
      console.error("Transcript URL is not available.");
    }
  }

  openSummary(SummaryUrl: string): void {
    if (SummaryUrl) {
      window.open(SummaryUrl, "_blank");
    } else {
      console.error("Summary URL is not available.");
    }
  }  

  updateRecordStatus(commentId: any, status: 'pending' | 'success' | 'error') {
    const record = this.dictationList.find(record => record.CommentId === commentId);
    if (record) {
      record.Status = status;
      // this.zone.run(() => this.cdr.detectChanges()); // Trigger change detection
      this.zone.run(() => {
        if (!this.isDestroyed) {
          this.cdr.detectChanges();
        }
      });
    }
  }

  fetchText(fileUrl: any) {
    this.textService.getTextFromUrl(fileUrl).subscribe(
      (response: string) => {
        this.fetchedText = response;
      },
      (error) => {
        console.error("Error fetching text:", error);
      }
    );
  }

  openEditPopup() {
    this.showEditsummaryModal = true;
  }

  showAiSummaryModalPopup() {
    this.showAiSummaryModal = true;
  }

  showSignedAiSummaryModalPopup() {
    this.showSignedAiSummaryModal = true;
  }

  closeEditModal() {
    this.editSummaryFlag = false;
    this.showEditsummaryModal = false;
    this.showAiSummaryModal = false;
    this.showShareSummaryModal = false;
    this.showSignedAiSummaryModal = false;
   
  }

  

  editSummaryFlagCondition() {
    this.editSummaryFlag = !this.editSummaryFlag;
  }

  setCommentId(commentId: any) {
    this.commentId = commentId;
  }

  generateTxtFile(text: string): Blob {
    const newText = `${text}`;
    const blob = new Blob([newText], { type: "text/plain" });
    return blob;
  }

  async uploadToAzure(value) {
    try {
      if (value == 0) {
        const txtBlob = this.generateTxtFile(this.fetchedText);
        if (!txtBlob) {
          throw new Error("Failed to generate text blob");
        }

        const alertStatus = await this.sweetAlertHelper.confirmPopUp(
          "Please Confirm",
          "Must sign prior to share"
        );
        if (alertStatus) {
          this.isSummaryEdited = 1;
          const editedBy = localStorage.getItem("loggedInUserName");
          const summaryFile = new File(
            [txtBlob],
            `summary_edited_by_${editedBy}.txt`,
            { type: "text/plain" }
          );
          const azureBody = new FormData();
          azureBody.append("fileKey", summaryFile);
          azureBody.append("loggedInUserId", this.loggedInUserId);
          const azureApiUrl =
            this.appConfig.getPhpUrl() + ApiHelper.php_uploadAzureFile;
          const res = await axios.post(azureApiUrl, azureBody, {
            headers: { "Content-Type": "multipart/form-data" },
          });
          if (res.data) {
            const fileUrl = res.data.commandResult.data.fileUrl;
            await this.updateEditedSummaryUrl(fileUrl);
          }
        } else {
          return false;
        }
      } else if (value == 1) {
        const txtBlob = this.generateTxtFile(this.fetchedText);
        var txtBlobText = await (txtBlob as any).text();
        if (!txtBlob) {
          throw new Error("Failed to generate text blob");
        }

        const alertStatus = await this.sweetAlertHelper.confirmPopUp(
          "Please Confirm",
          "I previewed this document electronically and signed. Please note, one electronically signed, this will be read only."
        );
        if (alertStatus) {
          this.isSummaryEdited = 1;
          this.isSummarySigned = 1;
          const today = new Date();
          const formattedDate = today.toLocaleString();
          const signedBy = localStorage.getItem("loggedInUserName");
          const finalText = `${txtBlobText}\n\n\nThis is electronically signed document\nSigned By: Dr. ${signedBy}\nDate: ${formattedDate}`;
          const summaryFile = new File(
            [finalText],
            `summary_signed_by_${signedBy}.txt`,
            { type: "text/plain" }
          );
          const azureBody = new FormData();
          azureBody.append("fileKey", summaryFile);
          azureBody.append("loggedInUserId", this.loggedInUserId);
          const azureApiUrl =
            this.appConfig.getPhpUrl() + ApiHelper.php_uploadAzureFile;
          const res = await axios.post(azureApiUrl, azureBody, {
            headers: { "Content-Type": "multipart/form-data" },
          });
          if (res.data) {
            const fileUrl = res.data.commandResult.data.fileUrl;
            await this.updateEditedSummaryUrl(fileUrl);
          }
        } else {
          return false;
        }
      }
    } catch (err) {
      console.error("Error uploading to Azure:", err);
    }
  }

  async updateEditedSummaryUrl(fileUrl) {
    const finalData = {
      commentId: this.commentId,
      editedSummaryUrl: fileUrl,
      isSummaryEdited: this.isSummaryEdited,
      isSummarySigned: this.isSummarySigned,
    };
    this.showLoader = true;
    this.http
      .post(
        this.appConfig.getLambdaUrl05() + ApiHelper.updateDictationSummary,
        finalData,
        this.httpOptions
      )
      .subscribe(
        async (res: any) => {
          this.showLoader = false;
          this.showEditsummaryModal = false;
          window.location.reload();
        },
        (err) => {
          this.showLoader = false;
          console.error(err);
        }
      );
  }

 
  // SHare with physicianas code

  openShareSummaryModal() {
    this.showShareSummaryModal = true;
  }

  onChangePractice(companyUrl) {
    const reqData = {
      company_slug: companyUrl,
      loggedInUserId: this.demographyUserId,
    };

    this.http
      .post(
        this.appConfig.getPhpUrl() + ApiHelper.php_findUserDoctorsByPracticeApi,
        reqData,
        this.httpOptions
      )
      .subscribe(
        (apiResponse: any) => {
          this.physicians1 = apiResponse.commandResult.data.companiesList;
        },
        (err) => {}
      );
  }

  getUserPractices() {
    const finalData = {
      loggedInUserId: this.demographyUserId,
    };
    this.showLoader = true;
    this.http
      .post(
        this.appConfig.getPhpUrl() + ApiHelper.php_findUserPracticeApi,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (apiResponse: any) => {
          this.practices = apiResponse.commandResult.data.companiesList;
          this.showLoader = false;
        },
        (err) => {
          console.error(err);
        }
      );
  }

  async listData() {
    if (this.physicianInfo1.length <= 0) {
      await this.sweetAlertHelper.alertPopUp(
        "Please select practice or physician"
      );
      return false;
    }
    if (this.physicianInfo1 == "all") {
      this.tempPractice01.push(
        this.practices.find((x) => x.company_url == this.practiceInfo1)
      );
    } else {
      this.physicianInfo1.forEach((element) => {
        const existingPhysician = this.finalPhysician01.find(
          (x) => x.physician_id == element
        );
        if (!existingPhysician) {
          const selectedPhysician = this.physicians1.find(
            (x) => x.physician_id == element
          );
          if (selectedPhysician) {
            this.finalPhysician01.push(selectedPhysician);
            this.tempPhysician01.push(selectedPhysician);

            this.selectedPhysiciansIdList.push(selectedPhysician.physician_id);
          }
        }
      });
    }
  }

  onChangePhysician(value, j) {
    if (value == "all" && j == 0) {
    }
    if (value == "all" && j == 1) {
    }
    if (value == "all" && j == 2) {
    }
    if (value == "all" && j == 3) {
    }
    if (value == "all" && j == 4) {
    }
  }

  
  shareSummaryWithPhysician() {
    const finalData = {
      patientId: this.demographyUserId,
      sendingPhysicianId: localStorage.getItem("loggedInUserId"),
      receivingPhysicianId: this.selectedPhysiciansIdList,
      dictationSummaryId: this.commentId,
    };


    // return
    this.showLoader = true;

    this.http
      .post(
        this.appConfig.getLambdaUrl05() +
          ApiHelper.postPhysicianSharedDictationSummary,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (apiResponse: any) => {
          if (apiResponse.commandResult.status == 1) {
            this.showShareSummaryModal = false;
            this.selectedPhysiciansIdList = [];
          }
          this.showLoader = false;
        },
        (err) => {
          // console.error(err);
        }
      );
  } 

  openSummaryPopup(documentId){   
    this.selectedAiSummary = this.documentsList.find(
      (e) => e.RecordId == documentId
    );    
    this.summaryPopup = true;
  }

  openConfirmSummaryPopup(documentId){
    this.selectedAiSummary = this.documentsList.find(
      (e) => e.RecordId == documentId
      );
    this.confirmSummaryPopup = true;
  }

  openRejectSummaryPopup(documentId){
    this.selectedAiSummary = this.documentsList.find(
      (e) => e.RecordId == documentId
    );
  }

  closeSummaryPopup(){
    this.summaryPopup = false;  
    this.confirmSummaryPopup = false;
    this.documentComment = '';
    this.summaryAnswer = '';
    this.isSummaryAnswer = false;
    this.saveSummaryBtn = false;
    this.summaryAskAnswer = "";
    this.questionToSummary = "";
    this.isSummaryInputVisible = false;
  }

  closeFacilityDetailsPopup(){
    this.openFacilityDetailsPopup = false;
  }
  
  openFacilityDetailsPopupWindow(documentId){
    this.facilityDetailsArray = [this.documentsList.find(
      (e) => e.RecordId == documentId
      )];
    this.openFacilityDetailsPopup = true;
  }
  showData(selectedVal) {
    this.showDataVal = selectedVal;
  }

  fnFindAllDocuments(docType) {
    this.documentsLength = 0
    let finalData;
    if(localStorage.getItem("isDelegating") == '1'){
      finalData = {
        patientId: this.demographyUserId,
        company_slug: ConstantHelper.COMPANY_SLUG,
        // email: this.profileObj.Email,
        physicianId: localStorage.getItem("delegateId"),
        userRoleId: this.loggedInUserRoleId,
      };
    } else {
      finalData = {
        patientId: this.demographyUserId,
        company_slug: ConstantHelper.COMPANY_SLUG,
        // email: this.profileObj.Email,
        physicianId: localStorage.getItem("loggedInUserId"),
        userRoleId: this.loggedInUserRoleId,
      };
    }
    this.showLoader = true;

    this.http
    .post(
          // this.appConfig.getLambdaUrl06() + ApiHelper.fetchAllDocumentsForPatientHistory,
            this.appConfig.getPhpUrl() + ApiHelper.php_fetchAllDocumentsForPatientHistory,
            finalData,
            this.httpOptions
        )
        .subscribe(
            (apiResponse) => {
                this.resultJsonObj = apiResponse;
                if (this.resultJsonObj.commandResult.data.documentList.length > 0) {
                    if (docType != '0') {
                        this.documentsList = this.resultJsonObj.commandResult.data.documentList.filter(doc => doc.DocumentCategoryId == docType);
                        this.documentsLength = this.documentsList.length;
                    } else {
                        this.documentsList = this.resultJsonObj.commandResult.data.documentList;
                        this.documentsLength = this.documentsList.length;
                    }
                } else {
                    this.documentsLength = 0;
                }
                this.showLoader = false;
            },
            (err) => {}
        );
  }
  
  // async generateSummary(documentUrl: string, extension: string, summary:string): Promise<void> {
  //   return new Promise<void>(async (resolve, reject) => {
  //     // alert(this.selectedAiSummary.DocumentUrl)
  //       this.showLoader = true;       
  //       const extension = await this.aiSummaryCommonHelper.checkDocumentType(this.selectedAiSummary.DocumentUrl);
  //       if(extension == "Video")
  //       {
  //         this.showLoader = false;
  //         this.isSummaryInputVisible = true; 
  //       }
  //       else
  //       {
  //         // this.showLoader = false;
  //         this.aiSummaryCommonHelper.summarizeReport(this.selectedAiSummary.DocumentUrl, extension,this.addFileDescription, this.addFileContent,this.flag).subscribe(
  //           (response) => {
  //               // this.showLoader = false;
  //               this.isSummaryAnswer = true;
  //               this.summaryAnswer = response.answer;
  //               const finalData = {
  //                 documentId: this.commentId,
  //                 aiSummary: this.summaryAnswer
  //               };
  //               this.selectedAiSummary.aiSummary = this.summaryAnswer;
  //               this.onSatisfactionResponse(true,finalData);                
  //               resolve(); // Resolve the Promise when summary is generated
  //               return this.selectedAiSummary;
  //           },
  //           (error) => {
  //               this.showLoader = false;
  //               console.error(error);
  //               reject(error); // Reject the Promise if there's an error
  //           }
  //       );
  //       }       
  //   });
  // }
  
  async generateSummary(documentUrl: string, extension: string, summary:string): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      // alert(this.selectedAiSummary.DocumentUrl)
        // this.showLoader = true;       
        // this.showLoader = false;
        this.isSummaryInputVisible = true;              
    });
  }
  
  
  async generateScreenCaptureSummary(documentUrl: string, addFileDescription:string,addFileContent:string ): Promise<void> {
    // let extension= "Video";
    this.showLoader = true;
    const extension = await this.aiSummaryCommonHelper.checkDocumentType(this.selectedAiSummary.DocumentUrl);  
    if(extension == "Video")
      {      
      if(!this.addFileDescription)
      {
        this.sweetAlertHelper.alertPopUp("Please Provide the video description and the content you are looking for")
        return;
      } 
      if(!this.addFileContent)
        {
          this.sweetAlertHelper.alertPopUp("Please Provide the content you are looking for")
          return;
        } 
      } 
      this.showLoader = true;
    // return new Promise<void>(async (resolve, reject) => {   
    try{    
        
        // let extension = await this.aiSummaryCommonHelper.checkDocumentType(documentUrl)     
        const generatedSummary = await this.aiSummaryCommonHelper.generateSummary(documentUrl,this.addFileDescription,this.addFileContent,extension,this.flag)
        this.summaryAnswer = generatedSummary;
        const finalData = {
          documentId: this.commentId,
          aiSummary: this.summaryAnswer
      };       
      const storeSummary = await this.onSatisfactionResponse(this.isSatisfied,finalData)       
      this.showLoader = false;
      this.isSummaryAnswer = true;
      this.isSummaryInputVisible = false; 
    }catch (error) {
      console.error("Error generating screen capture summary:", error);
      this.sweetAlertHelper.alertPopUp("An error occurred while generating the summary. Please try again.");
      this.showLoader = false; // Ensure loader is hidden in case of error
  }
    // });
  }
 
  async onSatisfactionResponse(isSatisfied: any, finalData: { documentId: any; aiSummary: string; }) {
    // alert(isSatisfied)
    if(isSatisfied)
    {
      await this.saveAiSummary()
    }
    else
    {
      this.isSummaryInputVisible = true;
      this.showModificationFields = true;      
    }
  }

  async saveAiSummary() {
    try {
        const finalData = {
            documentId: this.selectedAiSummary.RecordId,
            aiSummary: this.summaryAnswer
        };
        this.showLoader = true;
        await this.http.post(this.appConfig.getLambdaUrl05() + ApiHelper.generateAiSummaryByClick, finalData, this.httpOptions).toPromise();
        this.showLoader = false;
        window.location.reload();
    } catch (err) {
        console.error(err);
    }
  }

  // async saveAskSummary() {
  //   alert("save ask summary")
  //    this.savedAskQuestion = this.lastAskedQuestion;
  //   try {
  //       const finalData = {
  //           documentId: this.selectedAiSummary.RecordId,
  //           aiAskSummary: "Question:\n"+this.savedAskQuestion + "\nAnswer:\n" +this.summaryAskAnswer
  //       };     
  //       await this.http.post(this.appConfig.getLambdaUrl05() + ApiHelper.saveAiAskSummaryByClick, finalData, this.httpOptions).toPromise();
  //       // this.savedAskQuestion = this.questionToSummary;
  //       this.savedAskSummary = this.summaryAskAnswer;
  //       this.isAskSummaryAnswer = false;        
  //       this.questionToSummary = '';
        
  //   } catch (err) {
  //       console.error(err);
  //   }
  // }



async saveAskSummary() {
  // alert("save ask summary");

  try {
    const question = this.lastAskedQuestion || this.questionToSummary || '';
    const answer = this.summaryAskAnswer || '';

    // Get existing AiAskSummary text (if null/undefined, make it empty)
    let existingSummary = this.selectedAiSummary.AiAskSummary || '';

    // Append new Q&A in the desired format with bold text
    const newEntry = `\n<b>Question:</b> ${question}<br/><br/><b>Answer:</b> ${answer}<br/><hr style="border-bottom: 2px solid black; background-color: black; height: 2px;">`;
    existingSummary += newEntry;

    const finalData = {
      documentId: this.selectedAiSummary.RecordId,
      aiAskSummary: existingSummary
    };


    await this.http
      .post(
        this.appConfig.getLambdaUrl05() + ApiHelper.saveAiAskSummaryByClick,
        finalData,
        this.httpOptions
      )
      .toPromise();

    // Update local UI state
    this.selectedAiSummary.AiAskSummary = existingSummary;
    this.savedAskQuestion = question;
    this.savedAskSummary = answer;
    this.isAskSummaryAnswer = false;
    this.questionToSummary = '';

  } catch (err) {
    console.error(err);
  }
}


  cancelSave() {
  this.isAskSummaryAnswer = false;
}

  copyAiSummary(text: string) {
    let fullText = '';
    
    // Add AI Summary if available
    if (this.selectedAiSummary.AiSummary) {
      fullText += this.selectedAiSummary.AiSummary;
    }
    
    // Add AI Ask Summary if available
    if (this.selectedAiSummary.AiAskSummary) {
      if (fullText) {
        fullText += '\n\n'; // Add spacing between sections
      }
      fullText += this.selectedAiSummary.AiAskSummary;
    }
    
    // Add disclaimer at the end
    if (fullText) {
      fullText += '\n\n---\nDisclaimer: Clinical correlation is required. This is an AI-generated summary. Please review and verify all information for accuracy and completeness before making any clinical decisions.';
    }
    
    if (fullText) {
      const tempElement = document.createElement('div');
      tempElement.innerHTML = fullText; // Assign the HTML content
      const plainText = tempElement.textContent || tempElement.innerText || "";
      const tempTextArea = document.createElement('textarea');
      tempTextArea.value = plainText; 
      document.body.appendChild(tempTextArea);
      tempTextArea.select();
      document.execCommand('copy');
      document.body.removeChild(tempTextArea);
      this.copyTooltip = "Copied Summary";
      this.copyText = "Copied";
      setTimeout(() => {
        this.copyTooltip = "Copy Summary";
        this.copyText = "Copy";
      }, 2000);
    }
  }
  async askQuestion(){
    this.showLoader = true;
    const extension = await this.aiSummaryCommonHelper.checkDocumentType(this.selectedAiSummary.DocumentUrl);
    const question = this.questionToSummary;
    this.lastAskedQuestion = question;
    const prevSummary = this.selectedAiSummary.AiSummary;
    this.flag= 1;
    const askQueSummary = await this.aiSummaryCommonHelper.generateSummary(this.selectedAiSummary.DocumentUrl,question,prevSummary,extension,this.flag);
    this.isAskSummaryAnswer = true;
    this.summaryAskAnswer = askQueSummary;    
    this.showLoader = false;  
    this.questionToSummary = '';
  }
  clearfileds(){
    this.addFileContent = "";
    this.addFileDescription  = "";
    // Stop any ongoing recording
    this.stopRecording();
  }

  confirmOrObjectionSummary(action: string) {
    const activity = (action === 'confirmation') ? 'confirmation' : 'objection';
    const activityType = (action === 'confirmation') ? 1 : 0;

    const finalData = {
        documentId: +this.selectedAiSummary.RecordId,
        userId: localStorage.getItem("loggedInUserId"),
        activity: activity,
        documentComment: this.documentComment,
        activityType: activityType
    };
    this.showLoader = true;
    this.http
        .post(this.appConfig.getLambdaUrl05() + ApiHelper.documentConfirmObjectionPatientHistory, finalData, this.httpOptions)
        .subscribe(
            (apiResponse) => {
                this.showLoader = false;
                window.location.reload();
            },
            (err) => {
                // Handle error
            }
        );
    this.closeSummaryPopup();
}

getConfirmationObjectionComments(documentId){
  this.documentCommentDetails = [];
  const finalData = {
    userId: +this.loggedInUserId,
    documentId: +documentId
  };
  this.showLoader = true;

  this.http
    .post(this.appConfig.getLambdaUrl05() + ApiHelper.getDocumentConfirmObjectionPatientHistory, finalData, this.httpOptions)
    .subscribe(
      (res: any) => {
        if(res){
          if(res.commandResult.data.commentsInfo.length > 0){
            this.documentCommentDetails = res.commandResult.data.commentsInfo;
            this.showLoader = false;
            this.documentCommentDetailsLength = true
          } else {
            this.showLoader = false;
            this.documentCommentDetailsLength = false;
          }
        }
      },
      (err) => {
        this.showLoader = false;
        console.error(err);
      }
    );
}

// Clean up speech recognition on component destruction
ngOnDestroy() {
  this.isDestroyed = true;
  this.stopRecording();
  if (this.recognition) {
    this.recognition.abort();
  }
}

  //////////////////////////////////////////////////////////////////////////////////////////////////
}


